import styled from "styled-components";
import { Form } from "react-bootstrap";
import Select2 from "react-select";
import CreatableSelect2 from "react-select/creatable";

export const InputContainer = styled.div`
  position: relative;
  width: 100%;

  .label {
    display: flex;
    align-items: center;

    position: absolute;
    top: -8px;
    left: 12px;
    padding: 0 4px;
    background: #fff;
    color: #4d4c4d;
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 100%;

    svg {
      margin-left: 8px;
    }

    .required {
      color: #d93438;
    }
  }

  .chevron {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    height: 48px;
    right: 15px;
  }

  .trash {
    position: absolute;
    right: 10px;
    transform: translate(-50%, -50%);
    top: 50%;
    cursor: pointer;
  }

  &.fade {
    opacity: 0.4;
  }
`;

export const StyledInput = styled(Form.Control)`
  width: 100%;
  height: 48px;
  color: #4d4c4d;
  font-family: "Maison Neue Medium", sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
  padding: 12px 30px 12px 16px;
  border: 1px solid rgb(77, 76, 77);
  border-radius: 4px;
  outline: none;
  background: #fff;

  &:focus,
  &:focus-visible {
    border-color: rgb(77, 76, 77);
    color: #4d4c4d;
    text-shadow: none;
  }

  &.is-invalid {
    border-color: #ff7563;
  }

  &:disabled {
    background: #fff;
    opacity: 0.8;
  }

  &::-webkit-input-placeholder {
    font-family: "Maison Neue Light", sans-serif;
    font-weight: 300;
    color: #807e80;
    opacity: 0.8;
  }

  &:-ms-input-placeholder {
    font-family: "Maison Neue Light", sans-serif;
    font-weight: 300;
    color: #807e80;
    opacity: 0.8;
  }

  &::placeholder {
    font-family: "Maison Neue Light", sans-serif;
    font-weight: 300;
    color: #807e80;
    opacity: 0.8;
  }

  ${({ as }) =>
    as === "select" &&
    `
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: #fff;

    &.placeholder {
      font-family: "Maison Neue Light", sans-serif;
      font-weight: 300;
      color: #807e80;
      opacity: 0.8;
    }

    option {
      font-family: "Maison Neue Medium", sans-serif;
      font-weight: 300;
      color: #4d4c4d;
    }
  `}
`;

export const ContainerSelect2 = styled.div`
  position: relative;
  width: 100%;

  .label {
    position: absolute;
    top: -8px;
    left: 12px;
    padding: 0 4px;
    background: #fff;
    color: #4d4c4d;
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 100%;

    .required {
      color: #d93438;
    }
  }
`;

export const StyledSelect2 = styled(Select2)`
  height: 48px;

  .select__control {
    height: 48px;
    border: 1px solid rgb(77, 76, 77);

    &--is-disabled {
      background: transparent;
    }

    &--is-focused {
      border: 1px solid rgb(77, 76, 77);
      box-shadow: none;

      &:focus,
      &:hover {
        border: 1px solid rgb(77, 76, 77);
      }
    }

    .select__value-container {
      font-family: "Maison Neue Medium", sans-serif;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding-left: 16px;
      color: #4d4c4d;
			z-index: 0;

      .select__placeholder {
        font-family: "Maison Neue Light", sans-serif;
        font-weight: 300;
        color: #807e80;
        opacity: 0.8;
      }

      .select__multi-value {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f0f8;
        border-radius: 4px;

        .select__multi-value__label {
          color: #4d4c4d;
          font-family: "Maison Neue Medium", sans-serif;
          font-weight: 300;
          font-size: 12px;
          line-height: 17px;

          padding: 6px 3px 6px 6px;
        }

        .select__multi-value__remove {
          background: transparent;
          color: #892fb8;
          padding: 6px 6px 5px 3px;

          &:hover {
            background: transparent;
            color: #892fb8;
          }

          .border {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 12px;
            height: 12px;
            border: 1px solid #892fb8 !important;
            border-radius: 2px;
          }
        }
      }
    }

    .select__indicators {
      .select__indicator-separator {
        width: 0;
      }

      .select__dropdown-indicator {
        margin-right: 8px;
        color: #4d4c4d;
      }

      .select__clear-indicator {
        color: #fff;

        .border {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          background: #d93438;
          border-radius: 3px;
          border: none !important;
        }
      }
    }
  }

  .select__menu {
    margin-top: 0;
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 14px;
  }
`;

export const StyledCreatableSelect2 = styled(CreatableSelect2)`
  height: 48px;

  .select__control {
    height: 48px;
    border: 1px solid rgb(77, 76, 77);

    &--is-disabled {
      background: #fff;
    }

    &--is-focused {
      border: 1px solid rgb(77, 76, 77);
      box-shadow: none;

      &:focus,
      &:hover {
        border: 1px solid rgb(77, 76, 77);
      }
    }

    .select__value-container {
      font-family: "Maison Neue Medium", sans-serif;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding-left: 16px;

      .select__placeholder {
        font-family: "Maison Neue Light", sans-serif;
        font-weight: 300;
        color: #807e80;
        opacity: 0.8;
      }

      .select__multi-value {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f0f8;
        border-radius: 4px;

        .select__multi-value__label {
          color: #4d4c4d;
          font-family: "Maison Neue Medium", sans-serif;
          font-weight: 300;
          font-size: 12px;
          line-height: 17px;

          padding: 6px 3px 6px 6px;
        }

        .select__multi-value__remove {
          background: transparent;
          color: #892fb8;
          padding: 6px 6px 5px 3px;

          &:hover {
            background: transparent;
            color: #892fb8;
          }

          .border {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 12px;
            height: 12px;
            border: 1px solid #892fb8 !important;
            border-radius: 2px;
          }
        }
      }
    }

    .select__indicators {
      .select__indicator-separator {
        width: 0;
      }

      .select__dropdown-indicator {
        margin-right: 8px;
        color: #4d4c4d;
      }

      .select__clear-indicator {
        color: #fff;

        .border {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          background: #d93438;
          border-radius: 3px;
          border: none !important;
        }
      }
    }
  }

  .select__menu {
    margin-top: 0;
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 14px;
  }
`;

export const DateContainer = styled.div`
  position: relative;
  width: 100%;

  .label {
    position: absolute;
    top: -8px;
    left: 12px;
    padding: 0 4px;
    background: #fff;
    color: #4d4c4d;
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 14px;
    line-height: 100%;
    z-index: 5;

    .required {
      color: #d93438;
    }
  }

  & .input-container *:not(input) {
    font-family: "Maison Neue Medium", sans-serif;
    font-weight: 300;
    font-size: 12px;
    color: #4d4d4d;

    border: none;

    .datetime-popper {
      z-index: 99;
      padding-bottom: 8px;

      & > div .react-datepicker {
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14),
          0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
      }

      .react-datepicker__day--selected,
      .react-datepicker__day--keyboard-selected {
        background: #d93438 !important;
        color: #fff;

        &:hover {
          background: #d93438cc;
        }
      }
    }
  }

  input {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;

    height: 48px;
    width: 100%;

    font-family: "Maison Neue Thin", sans-serif;
    font-weight: 900;
    font-size: 14px;
    color: #4d4c4d;
    cursor: pointer;

    border: 0.5px solid rgb(77, 76, 77);
    border-radius: 4px;
    outline: none;
    text-align: left;
    background: transparent;

    padding-left: 16px;

    &::-webkit-input-placeholder {
      font-family: "Maison Neue Light", sans-serif;
      font-weight: 300;
      color: #807e80;
      opacity: 0.8;
    }

    &:-ms-input-placeholder {
      font-family: "Maison Neue Light", sans-serif;
      font-weight: 300;
      color: #807e80;
      opacity: 0.8;
    }

    &::placeholder {
      font-family: "Maison Neue Light", sans-serif;
      font-weight: 300;
      color: #807e80;
      opacity: 0.8;
    }
  }

  .date-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    transform: translate(0, -50%);
    top: 50%;
    right: 16px;
    z-index: 1;

    svg {
      stroke: #4d4c4d;
    }
  }

  .react-datepicker-wrapper {
    .react-datepicker__input-container {
      z-index: 2;

      input {
        width: 100%;
        text-align: left;
        color: #4d4c4d;
      }
    }
  }
`;

export const TooltipText = styled.div`
  cursor: pointer;
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 30px;
  visibility: hidden;
  min-width: fit-content;
  padding: 16px;

  word-wrap: break-word;
  white-space: nowrap;

  z-index: 1;

  background: #ffffff;

  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 12px;

  div {
    display: flex;
    align-items: flex-start;

    p {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;

      margin-left: 12px;
    }

    & + div {
      margin-top: 16px;
    }
  }
`;

export const TooltipCard = styled.div`
  position: relative;

  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
  }
`;
